"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPORT_STRATEGIES = exports.TABS = exports.FULL_ROUTES = exports.QUOTES_ROUTE = exports.PRODUCTS_ROUTE = exports.UPGRADE_PRODUCT = exports.PRODUCTS_SCREEN_NAME = exports.APP_NAME = void 0;

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var APP_NAME = 'settings';
exports.APP_NAME = APP_NAME;
var PRODUCTS_SCREEN_NAME = 'products';
exports.PRODUCTS_SCREEN_NAME = PRODUCTS_SCREEN_NAME;
var UPGRADE_PRODUCT = 'sales-professional';
exports.UPGRADE_PRODUCT = UPGRADE_PRODUCT;
var PRODUCTS_ROUTE = 'products';
exports.PRODUCTS_ROUTE = PRODUCTS_ROUTE;
var QUOTES_ROUTE = 'quotes';
exports.QUOTES_ROUTE = QUOTES_ROUTE;
var FULL_ROUTES = {
  PRODUCTS: "sales/" + _UrlPathParams.PRODUCTS,
  QUOTES: "sales/" + _UrlPathParams.PRODUCTS + "/" + QUOTES_ROUTE
};
exports.FULL_ROUTES = FULL_ROUTES;
var TABS = {
  PRODUCTS: PRODUCTS_ROUTE,
  QUOTES: QUOTES_ROUTE
};
exports.TABS = TABS;
var EXPORT_STRATEGIES = (0, _keyMirror.default)({
  BY_ID: null,
  CONTACTS_SEARCH: null
});
exports.EXPORT_STRATEGIES = EXPORT_STRATEGIES;